// extracted by mini-css-extract-plugin
module.exports = {"adContainer":"GoogleAdvertisement_adContainer__27c0L","landscape":"GoogleAdvertisement_landscape__3GDij","portrait":"GoogleAdvertisement_portrait__3BiVW"};